import { ApiPermissions } from "../cefi";
import { OrderSide, OrderType } from "../shared";
import { DropListWithIconItem } from "../structures";
import { MarketPair, PreparedOrder } from "../untrustedApi";
import { AccountId, VaultItem } from "../vault";
import { WidgetConfig } from "../widgets";

export type SelectedAccount = DropListWithIconItem<{
  cexValue: string;
  permissions: ApiPermissions[];
  exchangeUserId?: string;
  isConnected: boolean;
}> | null;

export type TradeForm = {
  tokenFrom: DropListWithIconItem | null;
  amountFrom: string | null;
  tokenTo: DropListWithIconItem | null;
  amountTo: string | null;
  selectedAccount: SelectedAccount;
  market: MarketPair | null;
  orderSide: OrderSide | null;
  addCexRedirect?: VoidFunction;

  /**
   * The limit price for the trade (Only used for limit orders)
   */
  limitPrice: string;
  /**
   * Ensure that the trade form does not have a common market between the two tokens.
   * This is used to trigger the trade square feature only when we are sure that the trade is not possible on the common market
   */
  noCommonMarket?: boolean;
  initialProps: WidgetConfig;
};

export type TradeConfirmationLocationState = {
  tokenFrom: DropListWithIconItem;
  tokenTo: DropListWithIconItem;
  amountFrom: string;
  amountTo: string;
  market: MarketPair;
  account: {
    label: string;
    value: string;
    img: string;
    cexValue: string;
    id: AccountId;
  };
  vault: VaultItem;
  createOrderRequest: PreparedOrder;
  rate: string;
  orderSide: OrderSide;
  orderType: OrderType;
  limitPrice: string;
};
